import React, { FC } from 'react';

type PropsT = {
  fill?: string;
};

const ShrinkIcon: FC<PropsT> = ({ fill }) => (
  <svg width="9" height="9" viewBox="0 0 9 9" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M0.166447 8.83355C0.387407 9.05548 0.745982 9.05548 0.966942 8.83355L7.8671 1.9334V5.00843C7.8671 5.32049 8.12101 5.5744 8.43403 5.5744C8.74706 5.5744 9 5.32049 9 5.00843V0.565968C9 0.252941 8.74706 0 8.43403 0H3.99158C3.67952 0 3.42561 0.252941 3.42561 0.565968C3.42561 0.878995 3.67952 1.1329 3.99158 1.1329H7.0666L0.166447 8.03306C-0.0554823 8.25402 -0.0554823 8.61259 0.166447 8.83355Z" fill={fill || "#909090"}/>
  </svg>
  
);

export default ShrinkIcon;
import React, { FC } from 'react';

type PropsT = {
  fill?: string;
};

const ShrinkIcon: FC<PropsT> = ({ fill }) => (
  <svg width="9" height="9" viewBox="0 0 9 9" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M0.166447 8.83355C0.387407 9.05548 0.745982 9.05548 0.966942 8.83355L7.8671 1.9334V5.00843C7.8671 5.32049 8.12101 5.5744 8.43403 5.5744C8.74706 5.5744 9 5.32049 9 5.00843V0.565968C9 0.252941 8.74706 0 8.43403 0H3.99158C3.67952 0 3.42561 0.252941 3.42561 0.565968C3.42561 0.878995 3.67952 1.1329 3.99158 1.1329H7.0666L0.166447 8.03306C-0.0554823 8.25402 -0.0554823 8.61259 0.166447 8.83355Z" fill={fill || "#909090"}/>
  </svg>
  
);

export default ShrinkIcon;
